module.exports = __webpack_public_path__ + "img/avatar1.b6b4df4a.png";